module.exports = __webpack_public_path__ + "static/4-weyes-eee2b62fc9201b61d20a108d3c8f0dfe.jpg";